import styled from 'styled-components'
import { Flex } from '~/components/common/containers'

export const AppContainer = styled(Flex).attrs({
  fullHeight: true,
  fullWidth: true
})`
  background: ${({ theme, withBackground }) => withBackground ? theme._neo.ui02 : 'initial'};
  justify-content: center;
`
